export default "__VITE_ASSET__d6919a80__"